import React, { useEffect, useState } from 'react';
import { GoogleCalendarLink } from './GoogleCalendarLink';

export const Countdown = () => {
    const [targetDate] = useState(new Date('2024-10-19T19:00:00'))
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [isMarried, setIsMarried] = useState(false);

    useEffect(() => {
        const updateCountdown = () => {
            const now = new Date();
            const difference = targetDate.getTime() - now.getTime(); // Usa getTime para obter o valor em milissegundos

            let days = Math.floor(difference / (1000 * 60 * 60 * 24));
            let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((difference % (1000 * 60)) / 1000);

            if (difference <= 0) {
                setIsMarried(true);
                days = days * -1
                hours = hours * -1
                minutes = minutes * -1
                seconds = seconds * -1
            }

            setTimeLeft({ days, hours, minutes, seconds });
        };

        updateCountdown();
        const timer = setInterval(updateCountdown, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <section className='w-full mx-auto py-6 pb-16'>
            <h2 className='amatic-sc-regular text-5xl mb-3 text-center'>{isMarried ? 'Casados a' : 'Faltam'}</h2>
            <div className='flex flex-wrap w-5/6 mb-12  justify-center gap-2 mx-auto poppins-regular'>
                <Timer title='Dia(s)'  timeLeft={timeLeft.days} /> 
                <Timer title='Hora(s)'  timeLeft={timeLeft.hours} /> 
                <Timer title='Minuto(s)'  timeLeft={timeLeft.minutes} /> 
                <Timer title='Segundo(s)'  timeLeft={timeLeft.seconds} /> 
            </div>
            <div className='text-center'>
                <GoogleCalendarLink />  
            </div>
        </section>
    );
};

type TimerProps = {
    timeLeft: number,
    title: string,
}

const Timer = ({timeLeft, title}: TimerProps) => {
    return (
        <div className='bg-stone-200 rounded-lg w-1/3 md:w-32 h-28 text-center flex flex-col justify-center items-center'>
            <h4 className='text-3xl poppins-regular'>{timeLeft}</h4>
            <p className='poppins-light'>{title}</p>
        </div>
    )
}
